import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
//import { Alerts } from '../models';
import { ApiConfig } from '../config/apiConfig';
@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  private rootUrl: string;
  private alertsAPIUrl;

  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.alertsAPIUrl = ApiConfig.AlertsApiConfig;

  }
  

  getAlertsByUserId(alertObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.getAlertsByUserId}`, alertObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  
  
  
  saveRGANumber(alertObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.saveRGANumber}`, alertObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }


  setAlertAcknowledge(alertObj:any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.setAlertAcknowledge}`, alertObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }

   
  getSearchAlert(alertObj: any): Observable<any>{
    return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.searchAlerts}`, alertObj)
    .pipe(
      tap(() => {
 
      })
    ); 
   }

   writeAlert(alertObj: any): Observable<any>{
     return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.writeAlert}`, alertObj)
     .pipe(
       tap(() => {

       })
     );
   }

   createAlert(alertObj: any): Observable<any>{
    return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.createAlert}`, alertObj)
    .pipe(
      tap(() => {

      })
    );
  }

   cancelAlert(alertObj: any): Observable<any>{
     return this.http.post(`${this.rootUrl}${this.alertsAPIUrl.setAlertStatus}`,alertObj )
     .pipe(
      tap(() => {

      })
    );
   }
}
